<template>
    <section class="column is-8-desktop px-0 px-sm-2 mx-auto">
        <form method="POST" action="#" class="form form-register d-flex flex-column justify-content-center">
            <!--            @todo convert into a component -->
            <div v-if="errors" class="errors mb-4">
                <template v-for="(item) in errors">
                    <template v-if="Array.isArray(item)">
                        <div v-for="(error) in item" class="error">{{error}}</div>
                    </template>
                    <template v-else>
                        <div class="error">{{item}}</div>
                    </template>
                </template>
            </div>
            <div class="columns">
                <div class="column is-half">
                    <div class="field mb-4" :class="{ 'has-error': $v.form.name.$error }">
                        <label class="label mb-1" for="name">Full Hazards Name*</label>
                        <div class="control">
                            <input id="name" name="name" class="input" type="text"
                                   v-model.trim="$v.form.name.$model"/>
                        </div>
                        <div class="error" v-if="$v.$dirty && $v.form.name.$error">
                            {{getErrorMessage($v.form.name)}}
                        </div>
                    </div>
                </div>
                <div class="column is-half">
                    <div class="field mb-4" :class="{ 'has-error': $v.form.hazard_type_id.$error }">
                        <label class="label mb-1" for="uxoType">UXO Type*</label>
                        <div class="control">
                            <select id="uxoType" name="uxo_type" class="select" v-model="form.hazard_type_id">
                                <option value="">Select a Type</option>
                                <option v-for="(type) in filteredTypes" :value="type.id">{{type.name}}
                                </option>
                            </select>
                        </div>
                        <div class="error" v-if="$v.$dirty && $v.form.hazard_type_id.$error">
                            {{getErrorMessage($v.form.hazard_type_id)}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns">
                <div class="column is-half">
                    <div class="field mb-4" :class="{ 'has-error': $v.form.category_id.$error }">
                        <label class="label mb-1" for="category">Category*</label>
                        <div class="control">
                            <select id="category" name="category" class="select"
                                    v-model.trim="$v.form.category_id.$model">
                                <option value="" selected>Select a Category</option>
                                <option v-for="(category) in categories" :value="category.id">
                                    {{category.name}}
                                </option>
                            </select>
                        </div>
                        <div class="error" v-if="$v.$dirty && $v.form.category_id.$error">
                            {{getErrorMessage($v.form.category_id)}}
                        </div>
                    </div>
                </div>
                <div class="column is-half">
                    <div class="field mb-4" :class="{ 'has-error': $v.form.country_id.$error }">
                        <label class="label mb-1" for="nationality">Country of Origin*</label>
                        <div class="control">
                            <select id="nationality" name="nationality" class="select"
                                    v-model.trim="$v.form.country_id.$model">
                                <option value="" selected>Select a Country</option>
                                <option v-for="(country) in countries" :value="country.id">
                                    {{country.name}}
                                </option>
                            </select>
                        </div>
                        <div class="error" v-if="$v.$dirty && $v.form.country_id.$error">
                            {{getErrorMessage($v.form.country_id)}}
                        </div>
                    </div>
                </div>
            </div>
            <!-- @todo convert to component -->
            <div class="columns">
                <div class="column is-full">
                    <div class="field">
                        <label class="label mb-1">Upload files</label>
                    </div>
                    <div class="field position-relative mb-4">
                        <div class="upload">
                            <div class="control">
                                <div class="upload__select p1 t-dark-grey lh-reset bg-white px-1 px-sm-2 py-2">
                                    <file-upload
                                        id="fileUpload"
                                        class="file-upload"
                                        extensions="gif,jpg,jpeg,png,webp,pdf"
                                        accept="image/png,image/gif,image/jpeg,image/webp,application/pdf,text/csv,text/plain,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                        :multiple="true"
                                        :size="1024 * 1024 * 10"
                                        v-model="files"
                                        @input-filter="inputFilter"
                                        @input-file="inputFile"
                                        ref="upload">
                                        Choose files
                                    </file-upload>
                                </div>
                            </div>
                            <div class="control">
                                <button class="btn btn-upload" @click.prevent="$refs.upload.$children[0].$el.click()">
                                    Choose Files
                                </button>
                            </div>

                            <div class="upload__files mt-4" v-if="files.length">
                                <div class="t-navy lh-lg mb-1">Files to upload</div>
                                <ul class="files t-navy rows">
                                    <li class="file odd row px-1 px-sm-3 py-12px t-navy w-100"
                                        v-for="(file, index) in files"
                                        :key="file.id">
                                        <div class="d-flex w-100">
                                            <div class="column p-0 file__name fs-18 py-12px">{{file.name}}</div>
                                            <div class="column p-0 file__btn text-right">
                                                <a class="btn btn-ghost btn-small w-100 p-1"
                                                   @click.prevent="confirmDelete(file, index)"
                                                   v-scroll-to="{el: '#confirmDelete',offset: -120}">Delete</a>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="file row px-1 px-sm-3 py-12px t-navy w-100" v-if="showConfirm">
                                        <div class="d-flex w-100 align-items-center" id="confirmDelete">
                                            <div class="column is-8 font-weight-light p-0 py-12px">
                                                Are you sure you want to delete <strong>{{fileToDelete.name}}</strong>?
                                            </div>
                                            <div class="column p-0 buttons text-right">
                                                <a class="btn btn-ghost btn-small btn-small--navy w-100 p-1 mr-sm-2 mb-2 mb-sm-0"
                                                   @click.prevent="keepFile()">Keep</a>
                                                <a class="btn btn-ghost btn-small w-100 p-1"
                                                   @click.prevent="deleteFile()">Delete</a>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns">
                <div class="column is-full">
                    <div class="field mb-4" :class="{ 'has-error': $v.form.description.$error }">
                        <label class="label mb-1" for="description">Description*</label>
                        <div class="control">
                                    <textarea id="description" name="description" class="textarea"
                                              v-model.trim="$v.form.description.$model"></textarea>
                        </div>
                        <div class="error" v-if="$v.$dirty && $v.form.description.$error">
                            {{getErrorMessage($v.form.description)}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns">
                <div class="column is-full">
                    <div class="field mb-4">
                        <label class="label mb-1" for="operation">Additional Information</label>
                        <div class="control">
                            <textarea id="operation" name="operation" class="textarea"
                                      v-model.trim="$v.form.operation.$model"></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns">
                <div class="column is-full">
                    <div class="field mb-4">
                        <label class="label mb-1" for="action">Possible EOD action</label>
                        <div class="control">
                            <textarea id="action" name="action" class="textarea"
                                      v-model.trim="$v.form.action.$model"></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns">
                <div class="column is-full">
                    <div class="field mb-4">
                        <label class="label mb-1" for="notes">Notes</label>
                        <div class="control">
                            <textarea id="notes" name="notes" class="textarea"
                                      v-model.trim="$v.form.notes.$model"></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="field mx-auto mb-3">
                <button v-if="!loading" type="submit" class="btn btn-form" @click.prevent="submit">Add your
                    contribution
                </button>
                <pulse-loader v-if="loading" :loading="true" :color="'#E57722'" :size="'20px'"></pulse-loader>
            </div>
        </form>
        <form v-if="showUploader" method="POST" action="#"
              class="form form-register d-flex flex-column justify-content-center">
            <div class="columns">
                <div class="column is-full">
                    <div class="field">
                        <label class="label mb-1">Upload a file</label>
                    </div>
                    <div class="field position-relative mb-4">
                        <cat-uxo-uploader></cat-uxo-uploader>
                    </div>
                </div>
            </div>
        </form>
        <cat-uxo-modal v-if="modalVisible" @close="hideModal()">
            <h2 slot="header" class="text-center t-orange">Thank you for contributing to CAT-UXO</h2>
            <div slot="body" class="d-flex flex-column justify-content-center text-center w-75 mx-auto mb-5">
                <p>You’ll be
                    able to view your contribution by clicking the button below. You can keep track of your
                    contributions by visiting <a class="btn-link font-weight-normal" href="/settings/profile">your
                        profile.</a>
                </p>
            </div>
            <div slot="footer" class="d-flex justify-content-center">
                <a v-if="hazard" :href="hazard.url" class="btn btn-form mx-auto">View your contribution</a>
            </div>
        </cat-uxo-modal>
    </section>
</template>

<script>
    //@todo Move the uploader to a component
    //@todo Improve the upload to show error per file

    /* Upload process
        1. User enters details and selects files
        2. User clicks the save button to save the new hazard
        3. A HTTP POST request is made to API at `/api/v3/hazard/store` which stores the hazard information into the hazards table.
        4. The method also stores a reference to the hazard into the contribution table
            and sends a notification to the admin about a new record being created by a user.
        5. At the same time, the files are uploaded to S3 from the website API (NOT the database API)
            with the `/api/v1/upload` and once the files are stored, the reference to the files are stored in the
            database API with the `/api/v3/hazard/assets/store` method.
        6. The API method to store hazard files reference also stores the reference to contribution files table
     */

    import {axiosApi, axiosWeb} from "@/js/axios";
    import {required} from 'vuelidate/lib/validators';
    import MixinModal from '@/js/mixins/modal';
    import {mapGetters} from "vuex";
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
    import FileUpload from 'vue-upload-component';
    import vueScrollto from 'vue-scrollto';

    Vue.use(vueScrollto);

    export default {
        name: 'CatUxoFormContribute',
        mixins: [MixinModal],
        components: {
            FileUpload,
            PulseLoader,
        },
        props: {
            user: {
                type: Object,
                required: true,
            }
        },
        data: function () {
            return {
                showUploader: false,
                form: {
                    contributor: this.user,
                    name: '',
                    hazard_type_id: '',
                    category_id: '',
                    country_id: '',
                    files: '',
                    description: '',
                    operation: '',
                    action: '',
                    notes: '',
                },
                hazard: null,
                types: [],
                categories: [],
                countries: [],
                errors: [],
                files: [],
                uploadedFiles: [],
                loading: false,
                showConfirm: false,
                fileToDelete: null,
                fileToDeleteIndex: null,
            }
        },
        watch: {
            hazard: {
                handler: function (hazard) {
                    if (hazard) {
                        let endPoint = process.env.MIX_APP_URL + `/api/v1/upload?folder=hazards&id=${hazard.id}&user=${this.user.id}`;

                        this.files.forEach(function (e) {
                            e.postAction = endPoint
                        });

                        let fileUpload = this.$refs.upload;
                        fileUpload.active = true;
                    }
                },
                deep: true,
            },
        },
        methods: {
            fetchTypes() {
                return axiosApi.get(`/api/v3/hazard-types`)
                    .then(response => {
                        if (response.data) {
                            this.types = response.data.items
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },
            fetchCategories() {
                return axiosApi.get(`/api/v1/categories`)
                    .then(response => {
                        if (response.data) {
                            this.categories = response.data.data
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },
            fetchCountries() {
                return axiosApi.get(`/api/v1/countries`)
                    .then(response => {
                        if (response.data) {
                            this.countries = response.data.data
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },
            submit() {
                let $this = this;

                $this.$v.form.$touch();

                // Append the files
                $this.form.files = $this.files;

                if ($this.$v.form.$invalid) return;

                $this.errors = [];

                // Display the loading on the button
                $this.loading = true;

                // Add the contribution
                return axiosApi.post(`/api/v3/hazard/store`, $this.form).then(response => {
                    $this.hazard = response.data;

                    if ($this.files.length === 0) {
                        this.loading = false;
                        this.modalVisible = true;
                    }
                }).catch((error) => {
                    $this.loading = false;

                    if (error.response.status === 422) {
                        $this.errors = error.response.data.errors;
                    }

                    if (error.response.status === 500) {
                        $this.errors.push('Sever error. There was an unexpected problem. The contribution might have been already added, please check on the contributions page. If the issue continues, please contact us');
                    }
                })
            },
            inputFilter(newFile, oldFile, prevent) {
                if (newFile && !oldFile) {
                    // Add a file

                    // Filter system files or hide files
                    if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                        return prevent()
                    }

                    // Filter php html js file
                    // php html js
                    if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
                        return prevent()
                    }
                }
            },
            inputFile(newFile, oldFile) {
                if (newFile && oldFile && !newFile.active && oldFile.active) {
                    if (newFile.xhr) {
                        if (newFile.success) {
                            let uploadedFile = {};
                            uploadedFile.name = newFile.name;
                            uploadedFile.type = newFile.type;
                            uploadedFile.folder = 'hazards';
                            uploadedFile.hazardId = this.hazard.id;

                            this.uploadedFiles.push(uploadedFile);
                        }

                        //  Get the response status code
                        if (this.$refs.upload.uploaded) {

                            // Save the paths to the database
                            this.saveHazardsAssets().then(() => {
                                this.modalVisible = true;
                                this.loading = false;
                            })
                        }
                    }
                }
            },
            confirmDelete(file, index) {
                this.fileToDelete = file;
                this.fileToDeleteIndex = index;
                this.showConfirm = true;
            },
            keepFile() {
                this.showConfirm = false;
                this.fileToDelete = null;
                this.fileToDeleteIndex = null;
            },
            deleteFile() {
                this.files.splice(this.fileToDeleteIndex, 1);
                this.showConfirm = false;
            },
            saveHazardsAssets() {
                return new Promise((resolve) => {
                    return axiosApi.post(`/api/v3/hazard/assets/store`, this.uploadedFiles).then(response => {
                        return resolve();
                    }).catch((error) => {
                        this.loading = false;

                        if (error.response.status === 500) {
                            this.errors.push('Hazard has been added but some files may not have been uploaded');
                        }
                    })
                })
            },
        },
        computed: {
            ...mapGetters('form', [
                'getErrorMessage',
            ]),
            filteredTypes() {
                return this.types.filter(function (type) {
                    return !(type.slug === 'not-set' || type.slug === 'ied');
                });
            }
            ,
            rules() {
                return {
                    name: {
                        required,
                    },
                    hazard_type_id: {
                        required,
                    },
                    category_id: {
                        required,
                    },
                    country_id: {
                        required,
                    },
                    description: {
                        required,
                    },
                    operation: {},
                    action: {},
                    notes: {}
                }
            }
            ,
        }
        ,
        created() {
            this.fetchTypes();
            this.fetchCategories();
            this.fetchCountries();
        }
        ,
        validations() {
            return {
                form: this.rules
            }
        },
        filters: {
            formatSize(size) {
                if (size > 1024 * 1024 * 1024 * 1024) {
                    return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
                } else if (size > 1024 * 1024 * 1024) {
                    return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
                } else if (size > 1024 * 1024) {
                    return (size / 1024 / 1024).toFixed(2) + ' MB'
                } else if (size > 1024) {
                    return (size / 1024).toFixed(2) + ' KB'
                }
                return size.toString() + ' B'
            }
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    .file {
        &:nth-child(even) {
            background: $c-light-grey;
        }

        &:nth-child(odd) {
            background: $c-white;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/forms/Contribute.vue